export default __webpack_public_path__ + "static/media/cycle_dash.82169fff.png";